import {
  ExclamationTriangleIcon,
  HomeIcon,
  NewspaperIcon,
  UserIcon,
  StarIcon,
  CheckBadgeIcon,
  BookmarkSquareIcon,
  CreditCardIcon,
} from "@heroicons/react/24/outline";
import { MdOutlineCategory } from "react-icons/md";

import { IconNames } from "components/Icon/Icon";
import { BsPersonVcard } from "react-icons/bs";
import { BiConversation } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";

export type IMenuChild = {
  id: string;
  label: string;
  Icon: any;
  disableBoard?: boolean;
  add?: boolean;
  addRightType?: string;
  addRightKey?: string;
  addRightKeyJoker?: string[];
  useWordingPlural?: boolean;
  isReservedForJuloa?: boolean;
};
export type IMenuGroup = {
  label: string;
  children: IMenuChild[];
  icon: IconNames;
  useWordingPlural?: boolean;
  isReservedForJuloa?: boolean;
};

export type IMenuConf = Record<string, IMenuGroup>;

/** ******************************** Sections ******************************* */

const followSection: IMenuConf = {
  // suivi
  suivi: {
    label: "monitoring",
    icon: "MdOutlineChecklist",
    children: [
      {
        id: "dashboard",
        label: "board",
        Icon: HomeIcon,
        disableBoard: true,
      } /* 
      {
        id: "emergencies",
        label: "emergencies",
        Icon: ExclamationCircleIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      }, */,
      {
        id: "reports",
        label: "reports",
        Icon: ExclamationTriangleIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "user-verifications",
        label: "userVerifications",
        Icon: CheckBadgeIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
    ],
  },
};

const managementSection: IMenuConf = {
  gestion: {
    label: "manage",
    icon: "MdOutlineChecklist",
    children: [
      {
        id: "contents",
        label: "contents",
        Icon: NewspaperIcon,
        add: true,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "conversations",
        label: "conversations",
        Icon: BiConversation,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "profiles",
        label: "profiles",
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "reviews",
        label: "reviews",
        Icon: StarIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
    ],
  },
};

const securitySection: IMenuConf = {
  security: {
    label: "security",
    icon: "MdOutlineChecklist",
    children: [
      {
        id: "users",
        label: "users",
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "subscriptions",
        label: "subscriptions",
        Icon: BookmarkSquareIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
      {
        id: "payments",
        label: "payments",
        Icon: CreditCardIcon,
        add: false,
        addRightKeyJoker: ["isAdmin"],
      },
    ],
  },
};

const mySpaceSection: IMenuChild[] = [
  {
    id: "my-account",
    label: "myAccount",
    Icon: UserIcon,
  },
  /* {
    id: "support",
    label: "support",
    Icon: SupportIcon,
  }, */
];

// const usersSection = {
//   id: "users",
//   label: "users",
//   Icon: UsersIcon,
//   add: true,
//   addRightType: "role",
//   addRightKey: "isAdmin",
// };

const adminUsersSection: IMenuChild[] = [
  {
    id: "categories",
    label: "categories",
    Icon: MdOutlineCategory,
    add: true,
    addRightKeyJoker: ["isAdmin"],
  }
];

const juloaAdminUsersSection: IMenuChild[] = [
  {
    id: "categories",
    label: "categories",
    Icon: MdOutlineCategory,
    add: true,
    addRightKeyJoker: ["isAdmin"],
  },
  {
    id: "configuration",
    label: "configuration",
    Icon: IoSettingsOutline,
    add: false,
    addRightKeyJoker: ["isAdmin"],
  },
];

/** **********************************  Menus by roles ************************** */

export const proMenu: IMenuConf = {
  ...followSection,
  ...managementSection,
  reglages: {
    label: "params",
    icon: "IoSettingsOutline",
    children: [...mySpaceSection],
  },
};

export const adminMenu: IMenuConf = {
  ...followSection,
  ...managementSection,
  ...securitySection,
  reglages: {
    label: "params",
    icon: "IoSettingsOutline",
    children: [...adminUsersSection, ...mySpaceSection],
  },
};

export const juloaAdminMenu: IMenuConf = {
  ...followSection,
  ...managementSection,
  ...securitySection,
  reglages: {
    label: "params",
    icon: "IoSettingsOutline",
    children: [...juloaAdminUsersSection, ...mySpaceSection],
  },
};
